import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function Layout({ children }) {
  const navigate = useNavigate();

  // ==========================
  // PEGAR NOME DO USUÁRIO
  // ==========================
  const usuarioNome = (() => {
    try {
      const raw = localStorage.getItem("usuario");
      if (!raw) return "";
      const parsed = JSON.parse(raw);
      return parsed.nome || parsed.Nome || "";
    } catch {
      return "";
    }
  })();

  // ==========================
  // LOGOUT
  // ==========================
  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <Box sx={{ p: 2 }}>

      {/* BARRA SUPERIOR */}
      <Box
        sx={{
        mb: 3,
        pb: 1,
        pt: 1,
        px: 2,
        borderBottom: "1px solid #D4EEF7",
        background: "rgba(0, 153, 204, 0.15)",
        backdropFilter: "blur(6px)",
        borderRadius: "0 0 12px 12px",
        display: "flex",                  // 🔥 GARANTE ELEMENTOS NA MESMA LINHA
        justifyContent: "space-between",  // 🔥 Nome à esquerda, SAIR à direita
        alignItems: "center",             // 🔥 Centraliza verticalmente
        }}
      >
        {/* Nome do usuário */}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
          {usuarioNome ? `Olá, ${usuarioNome}` : ""}
        </Typography>

        {/* Botão sair */}
        <Button
          variant="outlined"
          color="error"
          onClick={handleLogout}
        >
          Sair
        </Button>
      </Box>

      {/* CONTEÚDO DA PÁGINA */}
      <Box>{children}</Box>
    </Box>
  );
}
